<div class="echr-page-banner">
    <div class="court-logo  d-none d-lg-block"></div>
    <div class="app-name">
        <!--<a class="btn btn-link" routerLink="/">{{appName}}</a>-->
        <a class="btn btn-link"  style="font-size: inherit; text-align: left;" href="https://www.echr.coe.int/Pages/home.aspx?p=home">EUROPEAN COURT OF HUMAN RIGHTS<BR>COUR EUROPEENNE DES DROITS DE L'HOMME</a>
    </div>
    <!--<login-box class="app-buttons"></login-box>-->
</div>